/**
 * sets webpack publicPath on client side to runtime value
 * used in production bundle, in dev the path is set statically in webpack config
 */

// eslint-disable-next-line venom/no-prohibited-functions
if (window.EDM?.preloadedState !== undefined) {
  // eslint-disable-next-line no-undef, camelcase, venom/no-prohibited-functions
  __webpack_public_path__ = window.EDM.preloadedState.config.publicPath; // compiled to __webpack_require__.p...
} else if (window.EDM?.Venom?.clientConfig !== undefined) {
  // eslint-disable-next-line no-undef, camelcase
  __webpack_public_path__ = window.EDM.Venom.clientConfig.publicPath; // compiled to __webpack_require__.p...
}
